import { AdminLayout } from "../shared/layout";

export function AdminDashboardScreen() {
  return (
    <AdminLayout title="Panel">
      <main>
        <h1>Yönetici paneli </h1>
      </main>
    </AdminLayout>
  );
}
